/**
 * @file useSafeInit
 */
import { useEffect } from 'react';
import { useSingleton } from './useSingleton';
export function useSafeInit(creator) {
  var unbind = useSingleton(creator);
  useEffect(function () {
    return unbind;
  }, []);
}